



import ForgotUserSection from '../sections/forgot_username/template_01';




import "./style.css";

const ForgotUserPage = ()=>{
return (
<div id="forgotUserPage" className="page">
  
  

  
  <ForgotUserSection desktopTitleToggle={ true }
    mobileTitleToggle={ true } />
  
  
  
</div>
)
}

export default ForgotUserPage;